module.exports = __webpack_public_path__ + "img/cadastro-banner.6879bb63.png";